export default function AddRound({
  width = "14",
  height = "18",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 18"
    >
      <path
        id="Polygon_200"
        data-name="Polygon 200"
        d="M9,0l9,14H0Z"
        transform="translate(0 18) rotate(-90)"
      />
    </svg>
  );
}
